module.exports = __webpack_public_path__ + "img/SwordSpecial.840f5afa.png";